import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams, useSearchParams } from "react-router-dom";

// import Logo from '../../Assets/Images/logo.png';
import logoLeft from '../../../../Assets/Images/Infosec/logo-left.png';
import logoRight from '../../../../Assets/Images/Infosec/logo-right.png';
import logoLeftMobile from '../../../../Assets/Images/Infosec/logo-left-mobile.png';
// import logoRightMobile from '../../../../Assets/Images/Infosec/logo-right-mobile.png';
// import bleatLogo from '../../../Assets/Images/Infosec/logo-bleat-desktop.png';
import bleatLogo from '../../../../Assets/Images/Infosec/bleat-logo.svg';
// import bleatLogoMobile from '../../../Assets/Images/Infosec/bleat-logo-mobile.png';
// import logo from '../../../Assets/Images/Infosec/logo.png';
import logoMobile from '../../../../Assets/Images/Infosec/logo-mob.png';

import useWindowDimensions from '../../../../Hooks/useWindowDimensions';

// import '../../../../infosecApp.scss'

const InfosecHeader = props => {

  const { windowWidth } = useWindowDimensions();
  const [resultPage, setResultsPage] = useState(false);
  const location  = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  // redirect to new Higher Ground InfoSec assessment domain
  // useEffect(() => {
  //   window.location.href = "https://infosec.highergroundit.com/?" + searchParams?.toString();
  // }, []);

  useEffect(() => {
    const pathname = location.pathname;
    const search = searchParams?.toString();
    // Match /infosec/results/:hash or /infosec/results/:hash/
    const resultsMatch = pathname.match(/^\/infosec\/results\/([^/]+)\/?$/);

    let newUrl;
    if (resultsMatch) {
      // Redirect to /results/:hash on new domain
      newUrl = `https://infosec.highergroundit.com/results/${resultsMatch[1]}${search ? `?${search}` : ''}`;
    } else {
      // Redirect to root of new domain with search params
      newUrl = `https://infosec.highergroundit.com/${search ? `?${search}` : ''}`;
    }
    window.location.href = newUrl;
  }, []);
  
  useEffect(() => {
    if (location.pathname.split("/").includes("results") || location.pathname.split("/").includes("invite-team") || location.pathname.split("/").includes("dashboard") ) {
      setResultsPage(true);
    }
  },[])
  return (
    <>
      <header style={{ backgroundColor: resultPage ? "#ffffff" : "#ffffff" }}>
        <div>
        <div className="header-wrapper">
        
        {windowWidth > 830 ? <div className="logo-left"><img src={logoLeft} alt="Logo" /></div> : <div className="logo-left"><img src={logoMobile} alt="Logo" /></div>}

          
          {/* <div className="assessment-title desktop" id="assessment-title">
            <p className="logo-text">Church Management Software Assessment</p>
            <p className="logo-subtext">ASSESSMENT</p>
          </div> */}

            {/* <div className="left-logo" style={{ }}><Link to ="/start"><img src={logoLeft} alt="church logo" width={170} height={64} style={{padding: "20px 30px 30px 30px"}}/></Link></div> */}

            <div className="assessment-title desktop">
              <p className="logo-text">Information Security Indicator</p>
              {/* <p className="logo-subtext">ASSESSMENT</p> */}
            </div>

          {windowWidth > 830 ? <div className="logo-right" style={{ }}><img src={logoRight} alt="Bleat" /></div> : <div></div>}

        {/* {windowWidth <= 830 ?
          (<div className="bleat-logo-mobile">
            <img src={bleatLogoMobile} alt="bleat logo" height="43px" width="auto" />
          </div>) : (<div className="bleat-logo"><img src={bleatLogo} alt="bleat logo" height="57px" width="50px" /></div>)} */}

        </div>
        </div>

      </header>
    </>
  )
}

export default InfosecHeader;
